import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import ChatContentContainer from "@/components/chat/chatContainer/ChatContentContainer/ChatContentContainer.vue";
import NoChatContainer from "@/components/chat/chatContainer/NoChatContainer.vue";
import { LayoutTypes } from "@/store/app/state";
import { GetterTypes } from "@/store";
import { Chat, ChatBlockingStatusEnum } from "@/store/chats/types";
import { useComputedValue } from "@/composables/useComputedValue";
import { onMounted, watch } from "vue";
import { setLayoutMessageHeight } from "@/utils/chat";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatContainer',
  setup(__props) {

const selectedChatId = useComputedValue<string | undefined>(
  GetterTypes.GET_SELECTED_CHAT_ID,
);
const selectedChat = useComputedValue<Chat | undefined>(
  GetterTypes.GET_SELECTED_CHAT,
);
const layoutType = useComputedValue<LayoutTypes>(GetterTypes.GET_LAYOUT_TYPE);
const blockingStatus = useComputedValue<ChatBlockingStatusEnum>(
  GetterTypes.GET_SELECTED_CHAT_BLOCKING_STATUS,
);

watch(blockingStatus, () => {
  setLayoutMessageHeight();
});

onMounted(() => {
  setLayoutMessageHeight();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(selectedChatId) && _unref(layoutType) !== _unref(LayoutTypes).MOBILE)
      ? (_openBlock(), _createBlock(NoChatContainer, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(selectedChatId) && _unref(selectedChat))
      ? (_openBlock(), _createBlock(ChatContentContainer, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})